import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { NbLayoutModule, NbSidebarModule } from '@nebular/theme';
import { textColorOn } from '@shared/utils/driver-app-branding';

/** Non-production builds tint the menu so they are never mistaken for production. */
const DEV_SIDEBAR_BACKGROUND = '#bbdaff';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout>
      <nb-layout-header [style.background-color]="headerBackground" fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar
        class="menu-sidebar"
        [class.dev-sidebar]="!isProduction"
        [style.--dev-sidebar-background]="isProduction ? null : devSidebarBackground"
        [style.--dev-sidebar-text]="isProduction ? null : devSidebarText"
        tag="menu-sidebar"
        state="compacted"
        responsive
      >
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
  imports: [NbLayoutModule, HeaderComponent, NbSidebarModule, FooterComponent],
})
export class OneColumnLayoutComponent {
  isProduction = environment.production;
  devSidebarBackground = DEV_SIDEBAR_BACKGROUND;
  // Like the driver app's brand colour: the theme's menu text (white in dark mode) was unreadable
  // on the fixed light tint, so pick black or white from the tint itself.
  devSidebarText = textColorOn(DEV_SIDEBAR_BACKGROUND);
  @Input() headerBackground: string;
}
